import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon.js';

export default createSvgIcon(
  <path d="M18.8395 5.1605H22v2.074h-3.1605v3.1606h-2.074V7.2346h-3.1606V5.1605h3.1605V2h2.0741zm-2.074 14.716v-6.321h2.074V22H2V5.1605h8.4444v2.074h-6.321v12.642z" />,
  'SquarePlus',
);
